<template>
  <div class="wecom-notify-container">
    <el-card class="stats-card">
      <div class="stats-wrapper">
        <div class="stat-item">
          <div class="stat-value">{{ pageData.todaySendCount || 0 }}</div>
          <div class="stat-label">今日推送</div>
        </div>
        <div class="stat-divider"></div>
        <div class="stat-item">
          <div class="stat-value">{{ pageData.totalBindCount || 0 }}</div>
          <div class="stat-label">绑定用户</div>
        </div>
      </div>
    </el-card>

    <el-card class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-edit-outline"></i>
        <span>发送通知</span>
      </div>

      <el-form ref="notifyForm" :model="form" :rules="formRules" label-width="100px">
        <el-form-item label="选择学校" prop="schoolId">
          <el-select v-model="form.schoolId" placeholder="请选择学校" clearable style="width: 100%;">
            <el-option label="全部学校" :value="null"></el-option>
            <el-option
              v-for="school in schoolList"
              :key="school.schoolId"
              :label="school.schoolName"
              :value="school.schoolId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推送范围" prop="targetScope">
          <el-radio-group v-model="form.targetScope">
            <el-radio label="all">全员通知</el-radio>
            <el-radio label="runner">跑腿员</el-radio>
            <el-radio label="merchant">商家</el-radio>
            <el-radio label="admin">管理员</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="消息格式" prop="msgType">
          <el-radio-group v-model="form.msgType">
            <el-radio label="text">文字</el-radio>
            <el-radio label="textcard">图文卡片</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="通知标题" prop="title" v-if="form.msgType === 'textcard'">
          <el-input v-model="form.title" placeholder="请输入通知标题" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="通知内容" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            :rows="5"
            maxlength="500"
            show-word-limit
            placeholder="请输入通知内容...">
          </el-input>
        </el-form-item>

        <el-form-item label="跳转链接" v-if="form.msgType === 'textcard'">
          <el-input v-model="form.url" placeholder="点击卡片跳转的链接，如 https://www.xytsongbay.cn"></el-input>
          <span class="form-tip">卡片模式下默认跳转至送呗首页</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="sending" :disabled="!canSend" @click="handleSend">
            {{ sending ? '发送中...' : '发送通知' }}
          </el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'WeComNotify',
  data() {
    return {
      pageData: {},
      form: {
        schoolId: null,
        targetScope: 'all',
        msgType: 'textcard',
        title: '【送呗通知】',
        content: '',
        url: ''
      },
      sending: false,
      schoolList: [],
      formRules: {
        content: [
          { required: true, message: '请输入通知内容', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入通知标题', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    canSend() {
      if (!this.form.content || this.form.content.trim().length === 0) {
        return false
      }
      if (this.form.msgType === 'textcard' && (!this.form.title || this.form.title.trim().length === 0)) {
        return false
      }
      return !this.sending
    },
    selectedSchoolName() {
      if (!this.form.schoolId) return '全部学校'
      const school = this.schoolList.find(s => s.schoolId === this.form.schoolId)
      return school ? school.schoolName : '全部学校'
    }
  },
  mounted() {
    this.loadPageData()
  },
  methods: {
    async loadPageData() {
      try {
        const [pageRes, schoolRes] = await Promise.all([
          this.$http.get('/wecom/admin/page'),
          this.$http.get('/wecom/school/config/list')
        ])

        if (pageRes.data.code === 200 && pageRes.data.data) {
          this.pageData = pageRes.data.data
        }

        if (schoolRes.data.code === 200 && schoolRes.data.data) {
          this.schoolList = schoolRes.data.data
        }
      } catch (e) {
        console.error('加载页面数据失败', e)
        this.$message.error('加载数据失败，请刷新重试')
      }
    },
    getScopeName(scope) {
      const map = {
        all: '全部用户',
        runner: '跑腿员',
        merchant: '商家',
        admin: '管理员'
      }
      return map[scope] || '全部用户'
    },
    handleSend() {
      this.$refs.notifyForm.validate(async (valid) => {
        if (!valid) return

        this.$confirm(`确定要发送通知给${this.selectedSchoolName}的${this.getScopeName(this.form.targetScope)}吗？`, '确认发送', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.doSend()
        }).catch(() => {})
      })
    },
    async doSend() {
      this.sending = true
      try {
        const sendData = {
          schoolId: this.form.schoolId,
          targetScope: this.form.targetScope,
          msgType: this.form.msgType,
          content: this.form.content
        }

        if (this.form.msgType === 'textcard') {
          sendData.title = this.form.title
          sendData.url = this.form.url || 'https://www.xytsongbay.cn'
        }

        const res = await this.$http.post('/wecom/admin/send', sendData)

        if (res.data.code === 200) {
          this.$message.success(res.data.msg || '发送成功')
          this.form.content = ''
          this.loadPageData()
        } else {
          this.$message.error(res.data.msg || '发送失败')
        }
      } catch (e) {
        console.error('发送通知失败', e)
        this.$message.error('发送失败，请重试')
      } finally {
        this.sending = false
      }
    },
    resetForm() {
      this.form = {
        schoolId: null,
        targetScope: 'all',
        msgType: 'textcard',
        title: '【送呗通知】',
        content: '',
        url: ''
      }
      this.$refs.notifyForm && this.$refs.notifyForm.resetFields()
    }
  }
}
</script>

<style scoped>
.wecom-notify-container {
  padding: 20px;
}

.stats-card {
  margin-bottom: 20px;
  background: linear-gradient(135deg, #00C2A8 0%, #00a894 100%);
  border: none;
}

.stats-card >>> .el-card__body {
  padding: 30px;
}

.stats-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-value {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

.stat-divider {
  width: 2px;
  height: 50px;
  background: rgba(255, 255, 255, 0.3);
  margin: 0 40px;
}

.form-card {
  border-radius: 8px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.card-header i {
  font-size: 20px;
  color: #00C2A8;
}

.form-tip {
  display: block;
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.el-radio >>> .el-radio__input.is-checked .el-radio__inner {
  background-color: #00C2A8;
  border-color: #00C2A8;
}

.el-radio >>> .el-radio__input.is-checked + .el-radio__label {
  color: #00C2A8;
}

.el-button--primary {
  background-color: #00C2A8;
  border-color: #00C2A8;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #00b39d;
  border-color: #00b39d;
}

.el-button--primary:disabled {
  background-color: #a0d7d2;
  border-color: #a0d7d2;
}
</style>
